import { render, staticRenderFns } from "./SearchResultsItem.vue?vue&type=template&id=07f6935c&"
import script from "./SearchResultsItem.vue?vue&type=script&lang=js&"
export * from "./SearchResultsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports